/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Listaspectcontainsnoneaspect15Inputs */



/**

* @param {_Filter_Class_Listaspectcontainsnoneaspect15Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_listaspectcontainsnoneaspect15 = /** @type {((inputs?: _Filter_Class_Listaspectcontainsnoneaspect15Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Listaspectcontainsnoneaspect15Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("beinhaltet keines von")
});
export { _filter_class_listaspectcontainsnoneaspect15 as "_filter_class_ListAspectCONTAINSNONEAspect" }